<mat-chip-grid #chipGrid aria-label="inputPlaceholder">
    @for (item of selectedItems; track $index) {
        <mat-chip-row (removed)="remove(item)">
             {{ controller.getAutocompleteDisplayName(item, options) }}
          <button matChipRemove [attr.aria-label]="'remove ' + item">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
    }
</mat-chip-grid>

<input
        matInput
        mgdEnhancedControl
        #genericInput
        #inputControl="mgdEnhancedControl"
        [placeholder]="inputPlaceholder"
        [formControl]="inputFormControl"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipGrid"
        (matChipInputTokenEnd)="onMatChipInputTokenEnd($event)"
        (focus)="onInputFocus()"
        (blur)="onBlur()"
        />

<mat-autocomplete (optionSelected)="onOptionSelected($event)" #auto="matAutocomplete" [autoActiveFirstOption]="true">
    @let filteredItems = filteredItems$ | async;

    <ng-template #filteredOptions>
        @if (!multiple && !required) {
            <ng-content select="mat-option"></ng-content>
        }
        @for (item of filteredItems; track controller.trackByIdentifier($index, item)) {
            <mat-option [value]="item.value">{{item.option}}</mat-option>
        }
    </ng-template>

    @if (groupMessage) {
        <mat-optgroup [label]="groupMessage">
               <ng-container *ngTemplateOutlet="filteredOptions"></ng-container>
        </mat-optgroup>
    } 
    @else {
        <ng-container *ngTemplateOutlet="filteredOptions"></ng-container>
    }
</mat-autocomplete>
